<template>
    <div class="flex md6 offset-md3">
        <v-dialog
                value="true"
                fullscreen
                hide-overlay
                scrollable>
            <v-card tile>
                <v-toolbar card dark color="primary">
                    <img class="logo-sistema" alt="logo do sistema" :src="produtoLogo"/>
                    <div>
                        <p class="mb-0"><strong>{{usuarioLogado}}</strong></p>
                        <span>{{nomeLogado}}</span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark flat @click="logout" v-if="possuiPerfil === undefined || possuiPerfil === null">
                            Sair
                        </v-btn>
                        <v-btn dark flat @click="voltar" v-else>Voltar
                            <v-icon> keyboard_arrow_right</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-container fluid>
                    <v-form @submit.prevent="atualizarDominio">
                        <div class="area-interna">
                            <h3>Selecione {{ ehPerfilFornecedor ? 'a empresa' : $t('main.commons_selecionar_dominio_titulo.text') }} para acessar</h3>
                            <v-autocomplete id="auto-complete"
                                      :name="ehPerfilFornecedor ? 'Empresa' : $t('main.commons_selecionar_dominio_label.text')"
                                      :label="ehPerfilFornecedor ? 'Empresa' : $t('main.commons_selecionar_dominio_label.text')"
                                      :items="perfis"
                                      item-text="usuarioPerfil"
                                      item-value="chaveCliente"
                                      v-model="perfilId"
                                      v-validate="'required'"
                                      placeholder="Selecione"
                                      :error-messages="errors.collect(ehPerfilFornecedor ? 'Empresa' : $t('main.commons_selecionar_dominio_label.text'))"/>
                            <v-btn depressed color="primary" type="submit" class="text-uppercase">Entrar</v-btn>
                        </div>
                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {actionTypes} from '@/core/constants'

export default {
    name: 'SelecionarDominio',
    $_veeValidate: {
        validator: 'new'
    },
    inject: ['$validator'],
    data() {
        return {
            perfilId: this.$store.state.loki.user.domainId,
            perfis: this.$store.state.perfis,
            possuiPerfil: this.$store.state.loki.user.domainId,
            redirectUrl: null
        }
    },
    created() {
        const { query } = this.$route || {}
        const { redirectUrl } = query || {}
        if (redirectUrl) {
            this.redirectUrl = this.tryDecode(redirectUrl)
        }
        if (!this.perfis || this.perfis.length === 0) {
            this.$router.replace({ name: 'NaoAutorizado' })
        }
    },
    computed: {
        ehPerfilFornecedor() {
            return this.$store.state.loki.user.type === 'EXTERNO'
        },
        produtoLogo() {
            return this.$store.state.loki.product.symbolLogo
        },
        usuarioLogado() {
            return this.$store.state.loki.user.fullName.toUpperCase()
        },
        nomeLogado() {
            return this.$store.state.loki.user.name
        }
    },
    methods: {
        tryDecode(value) {
            if (!value) return value
            try {
                return decodeURIComponent(value)
            } catch (e) {
                return value
            }
        },
        async atualizarDominio() {
            const validado = await this.$validator._base.validateAll()
            if (!validado) {
                return
            }
            const perfil = this.getPerfil(this.perfilId)
            const dominioDTO = {
                dominioClienteId: perfil.chaveCliente,
                dominioTipo: perfil.tipoCliente
            }
            await this.$store.dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO, dominioDTO)
            if (this.redirectUrl) {
                this.irParaTelaComRedirecionamento()
            } else {
                this.irParaTelaInicial()
            }
        },
        getPerfil(chaveCliente) {
            const indice = this.perfis.findIndex(p => p.chaveCliente === chaveCliente)
            return this.perfis[indice]
        },
        irParaTelaInicial() {
            const url = `${window.location.origin}${window.location.pathname}`
            window.location.assign(url)
        },
        irParaTelaComRedirecionamento() {
            window.location.assign(this.redirectUrl)
        },
        logout() {
            const url = this.$store.state.loki.product.logoutUrl
            window.location.assign(url)
        },
        voltar() {
            this.$router.push({path: '/'})
        }
    }
}
</script>

<style scoped lang="stylus">
    .area-interna
        margin 100px auto
        padding 0
        background-color #fff
        width 40%
        display block
        text-align center
        box-sizing border-box

        h3
            border-bottom 1px solid #ccc
            line-height 20px
            padding 20px
            box-sizing border-box
            color var(--v-primary-base)

        .v-text-field
            margin 20px 50px

        .v-btn
            margin 0 auto 30px

    .logo-sistema
        width 35px
        margin-right 20px

    @media (max-width 900px)
        .area-interna
            width 60%

    @media (max-width 550px)
        .area-interna
            width 95%
</style>
